import { atom } from 'jotai';

interface OrphanedBookingSalesOrderLink {
  bookingId: string;
  documentNumber: string;
  salesOrderId: string;
  salesOrderNumber: string;
}

export const orphanedLinkAtom = atom<OrphanedBookingSalesOrderLink | null>(
  null,
);
